module.exports = __webpack_public_path__ + "static/media/Spark7.67ce377d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gJunior/Spark7.svg
// module id = 318
// module chunks = 21